// let customerUpdate = document.getElementById("editar-customer");
// console.log(customerUpdate)
//   if (customerUpdate != null) {
//     customerUpdate.addEventListener('click', (event) => {
//                 event.preventDefault();
//                 // const customer = document.querySelector('#edit-customer');
//                 Swal.fire({
//                     title: 'Actualizar datos de cliente',
//                     text: "",
//                     // icon: 'info',
//                     // input: 'text',
//                     html:
//                     `<label for="swal2-input" class="swal2-input-label">Nombre</label>
//                     <input id="swal-input1" class="swal2-input">`+
//                     `<label for="swal2-input" class="swal2-input-label">Apellido</label>
//                     <input id="swal-input2" class="swal2-input">`,
//                     showCancelButton: true,
//                     confirmButtonText: 'Aceptar',
//                     showLoaderOnConfirm: true,
//                     // inputValidator: function(option) {
//                     //     return new Promise(function(resolve, reject) {
//                     //         if (option != '' || option != null) {
//                     //             resolve();
//                     //         } else {
//                     //             reject('El campo no debe quedar vacio');
//                     //         }
//                     //     });
//                     // },
//                     focusConfirm: false,
//                     preConfirm: () => {
//                         return new Promise(function (resolve, reject) {
//                             // Validate input
//                             if ($('#swal-input1').val() == '' || $('#swal-input2').val() == '') {
//                                 Swal.disableButtons();	 // Enable the confirm button again.
//                                 Swal.hideLoading()	
//                                 swal.showValidationMessage("Ingrese valores validos"); // Show error when validation fails.
//                             } else {
//                                 swal.resetValidationMessage(); // Reset the validation message.
//                                 resolve(updateCustomer(customer.dataset.id,$('#swal-input1').val(),$('#swal-input2').val()));
//                             }
//                         })
//                     },
//                     // allowOutsideClick: () => !Swal.isLoading()
//                 }).then((result) => {
//                     // console.log(JSON.stringify(result.value[0]));
//                     // console.log(JSON.stringify(result.value[0]));
//                     if (result.isConfirmed) {
//                         console.log(result)
//                         Swal.fire({
//                             icon: `${result.value.icon}`,
//                             title: `${result.value.msg}`,
//                             allowOutsideClick: false,
//                             allowEscapeKey: false
//                         }).then((result) => {
//                             // Reload the Page
//                             location.reload();
//                         });
//                     }
//                 })
//             });

  
//   }

function updateCustomer(id, first_name, last_name)
{
    let data = {
        id: id,
        first_name: first_name,
        last_name: last_name
    };
    return fetch('https://piagui.engranedigital.com/facturacion/api/customer/updated', {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(response.statusText)

        }
        return response.json()
    })
    .catch(error => {
        Swal.showValidationMessage(
            `Request failed: ${error}`
        )
    })
}
document.addEventListener('DOMContentLoaded', function () {
  function replaceUrlParam(url, paramName, paramValue){
      if(paramValue == null || paramValue == "")
          return url
          .replace(new RegExp('[?&]' + paramValue + '=[^&#]*(#.*)?$'), '$1')
          .replace(new RegExp('([?&])' + paramValue + '=[^&]*&'), '$1');   
      url = url.replace(/\?$/,'');
      var pattern = new RegExp('\\b('+paramName+'=).*?(&|$)')
      if(url.search(pattern)>=0){
          return url.replace(pattern,'$1' + paramValue + '$2');
      }
      return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue 
  }
  function readCookieS(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }
    return null;
}
 window.onload = function() {
      const queryString2 = window.location.search;
      const urlParams2 = new URLSearchParams(queryString2);
      const string = urlParams2.get('whatsapp');
   var idSesion = readCookieS('waButtonId');
      if (string) {
        var date = new Date();
        date.setTime(date.getTime()+(2*60*60*1000));
        var expires = "; expires="+date.toGMTString();
        var whatsapp = string.split("-");
        document.cookie = "utm_whatsapp="+whatsapp[0]+expires+"; path=/";
        document.cookie = "utm_product="+whatsapp[1]+expires+"; path=/";
        
        jQuery.post('/cart/update.json', { attributes: {SessionID: `${idSesion}`,UTM_session: `${whatsapp[0]}`, UTM_product: `${whatsapp[1]}`}});
        
        console.log(whatsapp[0])
        console.log(whatsapp[1])
      }   
   // var utmWhatsapp = readCookieS('utm_whatsapp');
   // var utmProduct = readCookieS('utm_product');
   //  if (!utmWhatsapp || !utmProduct) {
   //    jQuery.post('/cart/update.json', { attributes: {SessionID: '', UTM_product: ''}});
   //  }

  var url = window.location.href;
   if(
     url === 'https://ninewestmexico.com/collections/mocasines-y-mules' || 
     url === 'https://ninewestmexico.com/collections/mocasines-y-mules/' ||
     url === 'www.ninewestmexico.com/collections/mocasines-y-mules' ||
     url === 'www.ninewestmexico.com/collections/mocasines-y-mules/' ||
     url === 'ninewestmexico.com/collections/mocasines-y-mules' ||
     url === 'ninewestmexico.com/collections/mocasines-y-mules/'){
     window.location.href = "https://ninewestmexico.com/collections/mocasines-y-mules/estilo";
   }


   
};
}, false);